/**
 * Deal statuses, and which of them represent money actually owed.
 *
 * A quote is a proposal — nothing has been signed and nobody owes anything.
 * A deposit is money taken before a binding contract, so the balance is not a
 * debt either. Only a sold deal carries one.
 */

export const OPEN_STATUSES = ["quote", "deposit"] as const;
// Delivered was folded into sold in patch 15: the two were never
// distinguishable, and nothing recorded a delivery date.
export const COMMITTED_STATUSES = ["sold"] as const;

/** True when the remaining balance on this deal is genuinely owed. */
export const balanceIsOwed = (status: string) =>
  (COMMITTED_STATUSES as readonly string[]).includes(status);
